var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"center mb-6 green lighten-1",attrs:{"large":"","justify":"center","rounded":"","align":"center"},on:{"click":function($event){return _vm.$emit('action')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }